import './Faqs.scss';

import { FAQ_QUESTIONS_ANSWERS, FAQ_SECTIONS } from './constants';
import { useEffect, useState } from 'react';

import { Button } from 'react-bootstrap';
import FaqCard from '../../components/FaqCard/FaqCard';
import SearchBar from '../../components/SearchBar/SearchBar';
import SubFooter from '../../components/SubFooter/SubFooter';
import bannerFaqImg from '../../assets/images/ubisoft-playtest-faq-banner.webp';
import bannerFaqImgMobile from '../../assets/images/ubisoft-playtest-faq-banner-mobile.webp';
import messages from './messages';
import { setTitle } from '../../utils/generic';
import { useIntl } from 'react-intl';

const Faqs = () => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState<number[]>([]);
  const [searchInput, setSearchInput] = useState('');
  const [faqs, setFaqs] = useState<any[]>([]);

  const handleChange = (e: any) => {
    e.preventDefault();
    setSearchInput(e.target.value);
    setIsOpen([]);
  };

  const clearSearch = () => {
    if (searchInput === '') return;
    setSearchInput('');
    setIsOpen([]);
  };

  useEffect(() => {
    setTitle(intl.formatMessage({ ...messages.faqTitle }));
  }, []);

  useEffect(() => {
    setFaqs(handleSearch());
  }, [searchInput]);

  const handleSearch = () => {
    return FAQ_SECTIONS.map((fs: any) => {
      return {
        id: fs.id,
        value: fs.value,
        faqQuestionAnswers: FAQ_QUESTIONS_ANSWERS.filter(
          (f: any) =>
            (f.sectionId === fs.id && searchInput.length === 0) ||
            (f.sectionId === fs.id &&
              searchInput.length > 0 &&
              (FAQ_QUESTIONS_ANSWERS.filter((x: any) => x.id === f.id).some(
                (x: any) =>
                  intl
                    .formatMessage({ ...x.question })
                    .toLocaleLowerCase()
                    .includes(searchInput.toLocaleLowerCase())
              ) ||
                FAQ_QUESTIONS_ANSWERS.filter((x: any) => x.id === f.id).some(
                  (x: any) =>
                    intl
                      .formatMessage({ ...x.answer })
                      .toLocaleLowerCase()
                      .includes(searchInput.toLocaleLowerCase())
                )))
        )
      };
    }).filter((x: any) => x.faqQuestionAnswers.length > 0);
  };

  return (
    <div className="page page-faq">
      <div className="page__header">
        <img src={bannerFaqImg} alt="" className="bannerImg bannerDesktop" />
        <img
          src={bannerFaqImgMobile}
          alt=""
          className="bannerImg bannerMobile"
        />
        <div className="blackOverlay" />
        <div className="content">
          <h1>{intl.formatMessage({ ...messages.faqTitle })}</h1>
        </div>
      </div>
      <div className="container faq">
        <SearchBar
          handleChange={handleChange}
          clearSearch={clearSearch}
          value={searchInput}
          placeholder={intl.formatMessage({ ...messages.searchBarDescription })}
        />
        <Button className="btn-close-all" onClick={() => setIsOpen([])}>
          {intl.formatMessage({ ...messages.closeAll })}
        </Button>
        <div className="faq-section-container">
          {faqs.map((fs: any) => (
            <div className="faq-section" key={fs.id}>
              <h2 className="faq-header">
                {intl.formatMessage({ ...fs.value })}
              </h2>
              {fs.faqQuestionAnswers.map((fqa: any) => (
                <FaqCard
                  id={fqa.id}
                  key={fqa.id}
                  question={intl.formatMessage({ ...fqa.question })}
                  anwser={intl.formatMessage({ ...fqa.answer })}
                  isOpen={isOpen.includes(fqa.id)}
                  toggleOpen={(id) => {
                    const index = isOpen.indexOf(id);
                    index > -1
                      ? setIsOpen(isOpen.filter((e) => e != id))
                      : setIsOpen([...isOpen.concat(fqa.id)]);
                  }}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="faq-contact">
        <SubFooter />
      </div>
    </div>
  );
};

export default Faqs;
